import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { organization as organizationSchema } from '../lib/schema.js';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';
import { selectEntities } from './entities.js';
import { RETRIEVE_ANCESTRY_SUCCESS } from './initiatives.js';

// API Actions

const RETRIEVE_ORGANIZATION_REQUEST =
  'changesync/organizations/RETRIEVE_ORGANIZATION_REQUEST';
const RETRIEVE_ORGANIZATION_SUCCESS =
  'changesync/organizations/RETRIEVE_ORGANIZATION_SUCCESS';
const RETRIEVE_ORGANIZATION_FAILURE =
  'changesync/organizations/RETRIEVE_ORGANIZATION_FAILURE';

const RETRIEVE_ORG_STRUCTURE_UPLOAD_STATUS_REQUEST =
  'changesync/organizations/RETRIEVE_ORG_STRUCTURE_UPLOAD_STATUS_REQUEST';
const RETRIEVE_ORG_STRUCTURE_UPLOAD_STATUS_SUCCESS =
  'changesync/organizations/RETRIEVE_ORG_STRUCTURE_UPLOAD_STATUS_SUCCESS';
const RETRIEVE_ORG_STRUCTURE_UPLOAD_STATUS_FAILURE =
  'changesync/organizations/RETRIEVE_ORG_STRUCTURE_UPLOAD_STATUS_FAILURE';

const HIDE_ORG_STRUCTURE_UPLOAD_ERROR_REQUEST =
  'changesync/organizations/HIDE_ORG_STRUCTURE_UPLOAD_ERROR_REQUEST';
const HIDE_ORG_STRUCTURE_UPLOAD_ERROR_SUCCESS =
  'changesync/organizations/HIDE_ORG_STRUCTURE_UPLOAD_ERROR_SUCCESS';
const HIDE_ORG_STRUCTURE_UPLOAD_ERROR_FAILURE =
  'changesync/organizations/HIDE_ORG_STRUCTURE_UPLOAD_ERROR_FAILURE';

const initialState = {
  organizationId: null,
  retrieveOrganization: {
    pending: false,
    success: false,
    error: null,
  },

  retrieveOrgStructureUploadStatus: {
    orgStructureUploadStatus: null,
    pending: false,
    success: false,
    error: null,
  },
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_ORGANIZATION_REQUEST:
      return {
        ...state,
        retrieveOrganization: {
          ...state.retrieveOrganization,
          pending: true,
          success: false,
          error: null,
        },
      };
    case RETRIEVE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        organizationId: action.payload.result,
        retrieveOrganization: {
          ...state.retrieveOrganization,
          pending: false,
          success: true,
        },
      };
    case RETRIEVE_ORGANIZATION_FAILURE:
      return {
        ...state,
        retrieveOrganization: {
          ...state.retrieveOrganization,
          pending: false,
          error: action.error,
        },
      };

    case RETRIEVE_ORG_STRUCTURE_UPLOAD_STATUS_REQUEST:
      return {
        ...state,
        retrieveOrgStructureUploadStatus: {
          ...state.retrieveOrgStructureUploadStatus,
          pending: true,
          success: false,
          error: null,
        },
      };
    case RETRIEVE_ORG_STRUCTURE_UPLOAD_STATUS_SUCCESS:
      return {
        ...state,
        retrieveOrgStructureUploadStatus: {
          ...state.retrieveOrgStructureUploadStatus,
          orgStructureUploadStatus:
            action.payload && Object.keys(action.payload).length
              ? action.payload
              : null,
          pending: false,
          success: true,
        },
      };
    case RETRIEVE_ORG_STRUCTURE_UPLOAD_STATUS_FAILURE:
      return {
        ...state,
        retrieveOrgStructureUploadStatus: {
          ...state.retrieveOrgStructureUploadStatus,
          pending: false,
          error: action.error,
        },
      };

    case RETRIEVE_ANCESTRY_SUCCESS:
      return {
        ...state,
        organizationId: action.payload.result.organization,
      };
    default:
      return state;
  }
};

// Action Creators

export const retrieveOrganization = (organizationId) => ({
  [CALL_API]: {
    types: [
      RETRIEVE_ORGANIZATION_REQUEST,
      RETRIEVE_ORGANIZATION_SUCCESS,
      RETRIEVE_ORGANIZATION_FAILURE,
    ],
    endpoint: `organizations/${organizationId}`,
    schema: organizationSchema,
  },
});

export const retrieveOrgStructureUploadStatus = (organizationId) => ({
  [CALL_API]: {
    method: HTTP_METHODS.GET,
    types: [
      RETRIEVE_ORG_STRUCTURE_UPLOAD_STATUS_REQUEST,
      RETRIEVE_ORG_STRUCTURE_UPLOAD_STATUS_SUCCESS,
      RETRIEVE_ORG_STRUCTURE_UPLOAD_STATUS_FAILURE,
    ],
    endpoint: `organizations/${organizationId}/organization_structure_upload`,
  },
});

export const hideOrgStructureUploadError = (organizationId) => ({
  [CALL_API]: {
    method: HTTP_METHODS.PUT,
    types: [
      HIDE_ORG_STRUCTURE_UPLOAD_ERROR_REQUEST,
      HIDE_ORG_STRUCTURE_UPLOAD_ERROR_SUCCESS,
      HIDE_ORG_STRUCTURE_UPLOAD_ERROR_FAILURE,
    ],
    endpoint: `organizations/${organizationId}/hide_errors`,
  },
});
// Selectors

export const selectRetrieveOrganizationState = createSelector(
  (state) => state.organizations,
  (organizations) => organizations.retrieveOrganization
);
export const selectRetrieveUploadStatusState = (state) =>
  state.organizations.retrieveOrgStructureUploadStatus;

const selectOrganizationId = (state) => state.organizations.organizationId;

export const selectOrganization = createSelector(
  selectOrganizationId,
  selectEntities,
  (organizationId, entities) =>
    denormalize(organizationId, organizationSchema, entities)
);
